import React from 'react';
import { Box, BoxProps } from '@hover/blueprint';
import { HOME_PAGE_CONTRACTOR_HOMEOWNER_MESSAGE } from '../../../../constants';
import ContractorHomeOwnerMessagePair from '../contractor-homeowner-message';

interface Props extends BoxProps {
  videoDuration: number | null;
}

const HeroMessageContainer: React.FC<Props> = ({
  videoDuration,
  ...restProps
}) => (
  <Box
    zIndex={100}
    pr={{ base: 0, desktop: 1100 }}
    flexDir="column"
    h={{ base: '210px', tablet: '175px' }}
    w="100%"
    position="absolute"
    bottom={0}
    overflow="hidden"
    alignItems={{ base: 'center', desktop: 'flex-end' }}
    {...restProps}
  >
    {videoDuration &&
      HOME_PAGE_CONTRACTOR_HOMEOWNER_MESSAGE.map(message => (
        <ContractorHomeOwnerMessagePair
          opacity={0}
          top={0}
          key={message.id}
          className="homeowner-contractor-message"
          contractorMessage={message.contractorMessage}
          homeOwnerMessage={message.homeOwnerMessage}
        />
      ))}
  </Box>
);

export default HeroMessageContainer;
